import memoizeOne from 'memoize-one'
import {
  getSampleWebhookPayload,
  getTestData
} from '../common/sample-formats/webhooks'
import {
  CARD_PRIORITY_DEFAULT,
  defaultCardActions
} from '../common/types/constants'
import {CardDefinition} from '../common/types/index'

export const emptyCardDefinition: CardDefinition = {
  metadata: {
    delivery: {
      priority: CARD_PRIORITY_DEFAULT
    },
    cardName: '',
    cardDescription: ''
  },
  variables: {},
  defaultView: {
    content: [],
    actions: []
  },
  subviews: {},
  actions: defaultCardActions
}

export const getSampleWebhookPayloadMemo = memoizeOne(getSampleWebhookPayload)
export const getTestDataMemo = memoizeOne(getTestData)

export const getCardTemplateUrl = (
  id: string,
  environmentId: string,
  organisationId: string
) => `/${organisationId}/${environmentId}/cards/${id}/content`

// all elements that collect user input
export const inputElementTypes = [
  'datePicker',
  'dropdown',
  'numberInput',
  'stepper',
  'switch',
  'textInput'
]

export const hasTopLevelInputs = memoizeOne(
  (definition: CardDefinition): boolean =>
    definition.defaultView?.content?.some(element =>
      inputElementTypes.includes(element.type)
    )
)

export const hasSubviewInputs = memoizeOne(
  (definition: CardDefinition): boolean =>
    Object.values(definition.subviews ?? []).some(subview =>
      subview.inputs?.some(element => inputElementTypes.includes(element.type))
    )
)
